import { isEmpty, isNil } from 'lodash-es';
import type React from 'react';
import type { FieldErrors } from 'react-hook-form';

export const onKeyUpDefault = (e: any) => {
  if (e?.target && e?.key === 'Enter') {
    e.target.blur();
  }
};

interface InputProps {
  id: string;
  label: string;
  type?: string;
  disabled?: boolean;
  autoCapitalize?: boolean;
  autoCorrect?: boolean;
  autoComplete?: string;
  options?: any;
  register: any;
  errors: FieldErrors;
  pattern?: string;
  step?: string;
  value?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: () => void;
}

const Input: React.FC<InputProps> = ({
  id,
  label,
  type = 'text',
  disabled,
  register,
  options,
  errors,
  pattern,
  step,
  autoCapitalize,
  autoCorrect,
  autoComplete,
  value,
  onFocus,
  onBlur,
  onKeyDown,
}) => (
  <div className="relative w-full">
    <input
      aria-label={label}
      autoCapitalize={
        !isNil(autoCapitalize) && autoCapitalize ? 'words' : 'none'
      }
      autoCorrect={!isNil(autoCorrect) && autoCorrect ? 'on' : 'off'}
      autoComplete={!isNil(autoComplete) && autoComplete ? 'on' : 'off'}
      data-test-id={`input-${id}`}
      id={id}
      disabled={disabled}
      {...register(id, options)}
      placeholder=" "
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      type={type}
      className={`peer w-full rounded-md border border-slate-300 bg-white p-4 py-3 font-light shadow-sm outline-none transition disabled:cursor-not-allowed disabled:opacity-70${
        errors[id] ? 'border-red-300' : 'border-slate-500'
      } ${errors[id] ? 'focus:border-red-300' : 'focus:border-black'}`}
      pattern={pattern || null}
      step={step || null}
      value={value || null}
    />
    <label
      htmlFor={id}
      className={`absolute start-1 top-1 origin-[0] -translate-y-4 scale-75 bg-white px-2 text-base leading-none duration-200 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-placeholder-shown:bg-transparent peer-focus:top-2 peer-focus:-translate-y-5 peer-focus:scale-75 peer-focus:bg-white peer-focus:px-2 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4 ${
        errors[id] ? 'text-red-500' : 'text-slate-500'
      }`}
    >
      {!isEmpty(errors[id]?.message) && typeof errors[id]?.message === 'string'
        ? `${errors[id]?.message}`
        : label}
    </label>
  </div>
);

export default Input;
